import { render, staticRenderFns } from "./GetResponse.vue?vue&type=template&id=18ddec4f&scoped=true&"
import script from "./GetResponse.vue?vue&type=script&lang=js&"
export * from "./GetResponse.vue?vue&type=script&lang=js&"
import style0 from "./GetResponse.vue?vue&type=style&index=0&id=18ddec4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ddec4f",
  null
  
)

export default component.exports